import React from 'react';
import { connect } from 'react-redux';
import Page from 'shared/Page';
import InventoryItemsContainer from '../../ticket-picker/containers/InventoryItemsContainer';
import { PickerWithDetailsMain } from './PickerWithDetailsMain';
import { getPickerWithDetailsSettings } from '../../../selectors/ui';
import InventoryContentContainer from '../../ticket-picker/containers/InventoryContentContainer';
import { PickerWithDetailsActions } from './PickerWithDetailsActions';
import CheckoutButton from '../../ticket-picker/containers/CheckoutButton';
import CouponEntryButton from '../../ticket-picker/containers/CouponEntryButton';
import { ContinueShoppingButton } from './ContinueShoppingButton';
import BestAvailableOrPyosPicker from '../../reserved-seating/containers/BestAvailableOrPyosPicker';
import InventoryErrors from '../../ticket-picker/containers/InventoryErrors';
import AlertContainer from '../../cart/containers/AlertContainer';

class PickerWithDetailsPage extends Page {
  map = {
    AlertContainer: AlertContainer,
    InventoryContentContainer,
    InventoryItemsContainer,
    PickerWithDetailsMain,
    CheckoutButton,
    PickerWithDetailsActions,
    CouponEntryButton,
    ContinueShoppingButton,
    BestAvailableOrPyosPicker,
    InventoryErrors
  }

  render() {
    return (
      <>
        {this.getComponents()}
      </>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
      settings: getPickerWithDetailsSettings(state),
  }
}

export default connect(mapStateToProps)(PickerWithDetailsPage);
